import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-time",
  "use": "icon-time-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-time\">\n<path d=\"M5.99963 11C8.76106 11 10.9996 8.76143 10.9996 6C10.9996 3.23857 8.76106 1 5.99963 1C3.23821 1 0.999634 3.23857 0.999634 6C0.999634 8.76143 3.23821 11 5.99963 11Z\" stroke=\"#999999\" stroke-linejoin=\"round\" />\n<path d=\"M6.00207 3L6.00177 6.0022L8.12162 8.12205\" stroke=\"#999999\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol